import { Injectable } from '@angular/core'
import { HighlightsStorage } from '@helios/generic-components'

@Injectable({
  providedIn: 'root',
})
export class MemoryStorageService implements HighlightsStorage {
  private readonly data: Record<string, unknown> = {} // In-memory data store

  async getValue<T>(key: string): Promise<T | undefined> {
    if (key in this.data) {
      // Return the stored data if it exists.
      return this.data[key] as T
    }
    return undefined // If the data doesn't exist, return undefined.
  }

  async setValue(key: string, value: unknown): Promise<void> {
    // Store the data in memory.
    this.data[key] = value
  }
}
